import config, { adminPrefix, getIsMaintenanceActive } from "~/config";

export default defineNuxtRouteMiddleware(async (to, from) => {
  if (getIsMaintenanceActive()) {
    return navigateTo(config.maintenancePage);
  }

  if (process.client) {
    const authStore = useAdminAuthStore();
    const orderStore = useOrderStore();
    const { $adminAuth } = useNuxtApp();

    const adminBookingRoute = adminPrefix("neukunde");
    if (
      from.path.startsWith(adminBookingRoute) &&
      !to.path.startsWith(adminBookingRoute)
    ) {
      // Reset the order store once the admin navigates away from the "create new customer" section:
      orderStore.reset();
    }

    if (!authStore.loggedIn) {
      await $adminAuth.signIn(to.fullPath);
    }
  }
});
